import React from 'react';
import './EmptyState.css';

/**
 * EmptyState component for displaying empty lists with call-to-action
 *
 * @param {string} icon - Emoji or icon to display
 * @param {string} title - Main message
 * @param {string} description - Optional longer description
 * @param {string} actionLabel - CTA button text
 * @param {function} onAction - CTA button click handler
 */
function EmptyState({
  icon = '📋',
  title = 'Nessun elemento trovato',
  description = null,
  actionLabel = null,
  onAction = null
}) {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">{title}</h3>
      {description && (
        <p className="empty-state-description">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          className="empty-state-action"
          onClick={onAction}
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
